const actions = {
  ADD_LOGI_BEGIN: 'ADD_LOGI_BEGIN',
  ADD_LOGI_SUCCESS: 'ADD_LOGI_SUCCESS',
  ADD_LOGI_ERR: 'ADD_LOGI_ERR',

  GET_LOGI_BEGIN: 'GET_LOGI_BEGIN',
  GET_LOGI_SUCCESS: 'GET_LOGI_SUCCESS',
  GET_LOGI_ERR: 'GET_LOGI_ERR',

  DELETE_LOGI_BEGIN: 'DELETE_LOGI_BEGIN',
  DELETE_LOGI_SUCCESS: 'DELETE_LOGI_SUCCESS',
  DELETE_LOGI_ERR: 'DELETE_LOGI_ERR',

  UPDATE_LOGI_BEGIN: 'UPDATE_LOGI_BEGIN',
  UPDATE_LOGI_SUCCESS: 'UPDATE_LOGI_SUCCESS',
  UPDATE_LOGI_ERR: 'UPDATE_LOGI_ERR',

  AddBegin: () => {
    return {
      type: actions.ADD_LOGI_BEGIN,
    };
  },

  AddSuccess: (data) => {
    return {
      type: actions.ADD_LOGI_SUCCESS,
      data,
    };
  },

  AddErr: (err) => {
    return {
      type: actions.ADD_LOGI_ERR,
      err,
    };
  },

  ReadBegin: () => {
    return {
      type: actions.GET_LOGI_BEGIN,
    };
  },

  ReadSuccess: (data) => {
    return {
      type: actions.GET_LOGI_SUCCESS,
      data,
    };
  },

  ReadErr: (err) => {
    return {
      type: actions.GET_LOGI_ERR,
      err,
    };
  },

  UpdateBegin: () => {
    return {
      type: actions.UPDATE_LOGI_BEGIN,
    };
  },

  UpdateSuccess: (data) => {
    return {
      type: actions.UPDATE_LOGI_SUCCESS,
      data,
    };
  },

  UpdateErr: (err) => {
    return {
      type: actions.UPDATE_LOGI_ERR,
      err,
    };
  },

  DeleteBegin: () => {
    return {
      type: actions.DELETE_LOGI_BEGIN,
    };
  },

  DeleteSuccess: (data) => {
    return {
      type: actions.DELETE_LOGI_SUCCESS,
      data,
    };
  },

  DeleteErr: (err) => {
    return {
      type: actions.DELETE_LOGI_ERR,
      err,
    };
  },
};

export default actions;
